import type { TabsProps } from 'rc-tabs';
import React, { lazy, Suspense } from 'react';

interface IConfig extends TabsProps {
  loading?: boolean;
}

const TabsLazy = lazy(() => import('./TabsLazy'));
const TabPaneLazy = lazy(() => import('./TabPaneLazy'));

const Tabs = ({ loading, children, ...props }: IConfig) => {
  return (
    <Suspense fallback={null}>
      <TabsLazy prefixCls="nui-tabs" {...props}>
        {children}
      </TabsLazy>
    </Suspense>
  );
};

export const TabPane = (props) => {
  return <TabPaneLazy {...props} />;
};

export default Tabs;
